import "./NftStaking.scss"
import React from "react"
import { Box } from "@mui/material"

import cronosCruiserBanner from "../../assets/icons/cronos-cruiser-banner.svg"

import Text from "../Text"

const NftEmptyView: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap="8px" alignItems="center">
      <Box alignItems="center" my={4}>
        <img src={cronosCruiserBanner} height="32px" />
      </Box>
      <Text>No Cronos Cruisers in Your Wallet</Text>
      <Text size="micro">
        {
          "It seems like you haven't got any Cronos Cruisers NFT yet. Get one from our NFT marketplace partner Minted now!"
        }
      </Text>
    </Box>
  )
}

export default NftEmptyView
